import(/* webpackMode: "eager" */ "/app/apps/nextjs/src/app/global-error.tsx");
